// Vendor
import { ElementRef, SimpleChanges } from '@angular/core';
import Highcharts from 'highcharts';
import XRangeModule from 'highcharts/modules/xrange';
import * as i0 from "@angular/core";
XRangeModule(Highcharts);
export class FactorCoefficientRangeChart {
    constructor(host) {
        this.host = host;
        this.el = host.nativeElement;
    }
    ngOnChanges(changes) {
        if (changes.rangeData?.currentValue)
            this.render();
    }
    render() {
        const { rangeData } = this;
        if (!rangeData)
            return;
        const scaleMin = Number(rangeData.scaleMinLabel);
        const scaleMax = Number(rangeData.scaleMaxLabel);
        const scaleRange = scaleMax - scaleMin;
        // Visual width of the current coefficient marker as a fraction of the scale range.
        // Keeps consistent pixel width across charts with different scales. (0.015 = 1.5%)
        const CURRENT_COEFFICIENT_MARKER_FRACTION = 0.015;
        const currentCoefficientMarkerWidth = scaleRange * CURRENT_COEFFICIENT_MARKER_FRACTION;
        const hasCategory = rangeData.categoryAverageCoefficient !== null && rangeData.categoryAverageCoefficient !== undefined;
        this.el.innerHTML = '';
        this.el.style.display = 'block';
        this.el.style.overflow = 'hidden';
        Highcharts.chart(this.el, {
            chart: {
                type: 'xrange',
                height: 60,
                backgroundColor: 'transparent',
                spacing: [0, 0, 0, 0],
                events: {
                    render() {
                        const chart = this;
                        // Remove previous custom elements
                        if (chart.customMarkerLine)
                            chart.customMarkerLine.destroy();
                        if (chart.customMarkerLabel)
                            chart.customMarkerLabel.destroy();
                        if (chart.leftTick)
                            chart.leftTick.destroy();
                        if (chart.rightTick)
                            chart.rightTick.destroy();
                        // Category average line - only for Funds
                        if (hasCategory) {
                            const x = chart.xAxis[0].toPixels(rangeData.categoryAverageCoefficient, false);
                            const lineHeight = 28;
                            const yTop = chart.plotTop + 17;
                            const yBottom = yTop + lineHeight;
                            // Draw Single vertical black line
                            chart.customMarkerLine = chart.renderer
                                .path(['M', x, yTop, 'L', x, yBottom])
                                .attr({ 'stroke': '#4c4c4c', 'stroke-width': 3, 'zIndex': 20 })
                                .add();
                            // Draw Label above vertical black line
                            chart.customMarkerLabel = chart.renderer
                                .text(rangeData.categoryAverageCoefficient.toFixed(2), x, yTop - 6)
                                .attr({ align: 'center', zIndex: 25 })
                                .css({ color: '#666666', fontSize: '12px' })
                                .add();
                        }
                        // Full scale end ticks - always shown, using scaleMin/Max
                        const minX = chart.xAxis[0].toPixels(scaleMin, false);
                        const maxX = chart.xAxis[0].toPixels(scaleMax, false);
                        const baselineY = chart.plotTop + 40;
                        const tickHeight = 22;
                        chart.leftTick = chart.renderer
                            .path(['M', minX, baselineY - tickHeight, 'L', minX, baselineY])
                            .attr({ 'stroke': '#bfbfbf', 'stroke-width': 2, 'zIndex': 10 })
                            .add();
                        chart.rightTick = chart.renderer
                            .path(['M', maxX, baselineY - tickHeight, 'L', maxX, baselineY])
                            .attr({ 'stroke': '#bfbfbf', 'stroke-width': 2, 'zIndex': 10 })
                            .add();
                    },
                },
            },
            title: { text: '' },
            credits: { enabled: false },
            legend: { enabled: false },
            tooltip: { enabled: false },
            xAxis: {
                gridLineWidth: 0,
                min: scaleMin,
                max: scaleMax,
                lineWidth: 0,
                tickLength: 0,
                labels: { enabled: false },
            },
            yAxis: {
                visible: false,
                min: -0.5,
                max: 0.5,
                categories: [''],
            },
            plotOptions: {
                series: {
                    states: { inactive: { opacity: 1 } },
                },
                xrange: {
                    grouping: false,
                    groupPadding: 0,
                    pointPadding: 0,
                    borderWidth: 0,
                    borderColor: 'transparent',
                    borderRadius: 0,
                    crisp: true,
                },
            },
            series: [
                // THIN GREY BASELINE
                {
                    type: 'xrange',
                    borderWidth: 0,
                    pointPadding: 0,
                    groupPadding: 0,
                    pointWidth: 3.3,
                    data: [{ x: scaleMin, x2: scaleMax, y: 0, color: '#bfbfbf' }],
                    zIndex: 1,
                },
                // PRIMARY SECURITY HISTORICAL RANGE (light blue)
                {
                    type: 'xrange',
                    borderWidth: 0,
                    pointPadding: 0,
                    groupPadding: 0,
                    pointWidth: 18,
                    data: [
                        {
                            x: rangeData.securityMinCoefficient,
                            x2: rangeData.securityMaxCoefficient,
                            y: 0,
                            color: '#BAD1EE',
                        },
                    ],
                    zIndex: 2,
                },
                // PRIMARY SECURITY CURRENT VALUE (dark blue)
                {
                    type: 'xrange',
                    borderWidth: 0,
                    pointPadding: 0,
                    groupPadding: 0,
                    pointWidth: 18,
                    data: [
                        {
                            x: rangeData.securityCurrentCoefficient,
                            x2: rangeData.securityCurrentCoefficient + currentCoefficientMarkerWidth,
                            y: 0,
                            color: '#578CD8',
                        },
                    ],
                    zIndex: 3,
                },
            ],
        });
    }
}
FactorCoefficientRangeChart.ɵfac = function FactorCoefficientRangeChart_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FactorCoefficientRangeChart)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
FactorCoefficientRangeChart.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FactorCoefficientRangeChart, selectors: [["ycn-factor-coefficient-range"]], inputs: { rangeData: "rangeData" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 0, vars: 0, template: function FactorCoefficientRangeChart_Template(rf, ctx) { }, encapsulation: 2 });
